import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbBackgroundWrapBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`background-wrap ${props.attributes.className ? props.attributes.className : ''} ${classes.backgroundWrap}`}>
        {blocks.map((block) => {
              return block;
          })}
    </div>
};

export const CgbBackgroundWrapBlockFragment = graphql`
  fragment CgbBackgroundWrapBlock on WpBlock {
    ... on WpCgbBackgroundWrapBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBackgroundWrapBlockPreview = `
    ... on CgbBackgroundWrapBlock {
        name
        attributes {
            className
        }
    }
`;